import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { LanguageService } from '../../services/language.service';
import { GoToPageService } from "../../services/go-to-page.service";
import { GoogleAnalyticsService } from "../../services/google-analytics.service";
import { DepositOriginService } from '../../services/deposit-origin.service';
import { isDepositOriginCode } from '../../services/deposit-origin';
/**
 * Questionnaire Component
 */
let QuestionnaireComponent = class QuestionnaireComponent {
    constructor(httpClient, sanitizer, themeService, router, languageService, goToService, googleAnalyticsService, depositOriginService) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.router = router;
        this.languageService = languageService;
        this.goToService = goToService;
        this.googleAnalyticsService = googleAnalyticsService;
        this.depositOriginService = depositOriginService;
        this.questionnaire = [];
        this.questions = [];
        this.backColor = '';
        this.accentColor = '';
        this.mainColor = '';
        this.borderRadiusLarger = '';
        this.borderRadiusSmaller = '';
        this.textColor = '';
        this.errorColor = '';
        this.successColor = '';
        this.linkColor = '';
        this.inputBackColor = '';
        this.errorMessage = "";
        this.sentEmailMessage = false;
        this.confirmationMessage = '';
        this.confirmationMessageError = '';
        this.provision = JSON.parse(localStorage.getItem('provision'));
        this.checkedAnswers = [];
        this.otherAnswers = [];
        this.orderData = JSON.parse(localStorage.getItem('orderData'));
        this.orderType = localStorage.getItem('orderType');
        this.riskLevel = localStorage.getItem('riskLevel');
        this.questionnaireSubmitted = localStorage.getItem("questionnaireSubmitted");
        this.lang = localStorage.getItem('language') ? localStorage.getItem('language') : 'sr';
        this.clicked = false;
        // the order questionnaire recorded on this page; a retry goes straight to the order
        this.questionnaireSubmissionId = null;
        if (this.questionnaireSubmitted === 'true') {
            this.router.navigateByUrl('');
        }
        this.themeService.getTheme().subscribe((data) => {
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        });
        if (this.orderType && this.orderData) {
            this.requestParametar = 'order_type_name=' + this.orderType;
        }
        else if (this.riskLevel) {
            this.requestParametar = 'risk_level=' + this.riskLevel;
        }
        else {
            this.router.navigateByUrl('');
        }
        this.httpClient.get('market/order/questionnaire?' + this.requestParametar + '&language_name=' + this.lang).subscribe((data) => {
            this.questionnaire = data[0];
            this.questions = this.questionnaire[0].questionnaire.questions;
        });
    }
    ngOnInit() {
        this.languageService.language.subscribe((language) => {
            this.lang = language;
            this.httpClient.get('market/order/questionnaire?' + this.requestParametar + '&language_name=' + this.lang).subscribe((data) => {
                this.questionnaire = data[0];
                this.questions = this.questionnaire[0].questionnaire.questions;
            });
        });
    }
    sendQuestionnaire() {
        if (Object.keys(this.checkedAnswers).length == 0) {
            this.errorMessage = 'QUESTIONNAIRE.ANSWER_ERROR';
            this.clicked = false;
            return;
        }
        let questionIds = [];
        let answers = Array();
        for (let i = 0; i < this.questions.length; i++) {
            questionIds[i] = this.questions[i].id;
        }
        for (let i = 0; i < questionIds.length; i++) {
            let allFalse = true;
            let optionsAnswers = Array();
            for (const key in this.checkedAnswers) {
                if (this.checkedAnswers[key] && Number(key.split('.')[0]) == questionIds[i]) {
                    allFalse = false;
                    for (let j = 0; j < this.questions[i].question_options.length; j++) {
                        if (this.questions[i].question_options[j].id == Number(key.split('.')[1]) && this.questions[i].question_options[j].customizable) {
                            if (this.otherAnswers[key] === undefined || this.otherAnswers[key] === "") {
                                this.errorMessage = 'QUESTIONNAIRE.TEXTAREA_ERROR';
                                this.clicked = false;
                                return;
                            }
                            else if (this.otherAnswers[key].length > 254) {
                                this.errorMessage = 'QUESTIONNAIRE.TEXTAREA_LENGTH';
                                this.clicked = false;
                                return;
                            }
                        }
                    }
                    const temp = {
                        'question_option_id': Number(key.split('.')[1]),
                        'customizable_value': this.otherAnswers[key] !== undefined ? this.otherAnswers[key] : null
                    };
                    optionsAnswers.push(temp);
                }
            }
            if (allFalse) {
                this.errorMessage = 'QUESTIONNAIRE.ANSWER_ERROR';
                this.clicked = false;
                return;
            }
            const temp = {
                'question_id': questionIds[i],
                'options_answers': optionsAnswers
            };
            answers.push(temp);
        }
        let result = {
            'questionnaire_id': this.questionnaire[0].questionnaire_id,
            'answers': answers
        };
        if (this.orderType && this.orderData) {
            if (this.questionnaireSubmissionId !== null) {
                this.createOrderDraft();
                return;
            }
            this.httpClient.post('market/order/questionnaire', result).subscribe((submissionData) => {
                this.questionnaireSubmissionId = submissionData['questionnaire_submission_id'];
                this.orderData.questionnaire_submission_id = this.questionnaireSubmissionId;
                this.createOrderDraft();
            });
        }
        else if (this.riskLevel) {
            result['risk_level'] = this.riskLevel;
            this.httpClient.post('market/order/questionnaire', result).subscribe((success) => {
                let type = window.history.state.type;
                let currency = window.history.state.currency;
                let meanOfPayment = window.history.state.meanOfPayment;
                let wallet = window.history.state.wallet;
                if (type && currency) {
                    this.goToService.goTo(type, currency, null);
                    let array = [];
                    array.push({
                        'event': 'buySellCTAclick',
                        button: type,
                        cryptoCurrency: currency
                    });
                    this.googleAnalyticsService.pushGAEvents(array);
                }
                else if (wallet) {
                    this.router.navigateByUrl('/wallet/cryptocurrencies');
                }
                else if (meanOfPayment) {
                    this.router.navigateByUrl('/buy' + '/' + currency + '/' + meanOfPayment + '/buy');
                }
                else {
                    this.router.navigateByUrl('');
                }
            });
        }
    }
    /** The order behind the questionnaire; the origin-of-funds window continues it when the deposit trigger stopped it. */
    createOrderDraft() {
        this.httpClient.post('market/order/draft/registred/' + this.orderType, this.orderData).subscribe((draftData) => {
            this.orderId = draftData['order_id'];
            localStorage.setItem('orderId', this.orderId);
            const data = {
                'questionnaire_submission_id': this.questionnaireSubmissionId,
                'order_type_name': this.orderType,
                'order_id': draftData['order_id'],
            };
            this.httpClient.post('market/order/questionnaireSubmission', data).subscribe((result) => {
                localStorage.setItem("questionnaireSubmitted", "true");
                if (draftData['status'] === 'Čekanje na dokumentaciju') {
                    this.httpClient.post('market/order/sendL2LimitInstructions', { order_id: this.orderId }).subscribe();
                    this.router.navigateByUrl('/documentation/' + draftData['order_id']);
                }
                else {
                    if (draftData['order_state'] === 'confirmed') {
                        this.router.navigateByUrl('/' + this.orderType + '/confirm/' + draftData['order_id']);
                    }
                    else if (draftData['order_state'] === 'unconfirmed') {
                        this.sentEmailMessage = true;
                    }
                }
            });
        }, (error) => {
            if (error.error && isDepositOriginCode(error.error.message)) {
                // the order's statement does not cover the deposit trigger: its window over this page, and the
                // order goes on once the window resolves the requirement
                this.clicked = false;
                this.depositOriginService.openForCode(error.error.message, () => {
                    // the button stays locked while the continued order is sent, as after a click
                    this.clicked = true;
                    this.createOrderDraft();
                });
                return;
            }
            if (error.error['message'] == 'ORDER_ALREADY_CREATED') {
                this.errorMessage = 'ORDER.CREATE_ORDER_DRAFT_ERROR';
                setTimeout(() => {
                    this.clicked = false;
                    this.errorMessage = '';
                }, 30000);
            }
        });
    }
    send_email_again() {
        this.confirmationMessage = '';
        this.confirmationMessageError = '';
        this.httpClient.post('market/order/draft/requestconfirm', { id: this.orderId }).subscribe((success) => {
            this.confirmationMessage = success['message'];
        }, (error) => {
            this.confirmationMessageError = error.error.message;
        });
    }
};
QuestionnaireComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: Router },
    { type: LanguageService },
    { type: GoToPageService },
    { type: GoogleAnalyticsService },
    { type: DepositOriginService }
];
QuestionnaireComponent = __decorate([
    Component({
        selector: 'ecd-questionnaire',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./questionnaire.component.html")).default
    })
], QuestionnaireComponent);
export { QuestionnaireComponent };
